module.exports = __webpack_public_path__ + "fonts/Bangers.36cfbe5.ttf";